(function($) {
    if ('' != $.trim($('#missing-information-modal .modal-content').html())) {
        $('#missing-information-modal').modal({
            backdrop:'static',
            keyboard: false,
            show: true
        });

        var $mobile = $('#wlz_user_missing_information_retrieve_mobile'),
            $phone = $('#wlz_user_missing_information_retrieve_phone1')
            ;
        $mobile.attr('required','required');
        $phone.change(function() {
            if($(this).val()) {
                $mobile.removeAttr('required', 'required');
            } else {
                $mobile.attr('required', 'required');
            }
        }).change();

        $mobile.intlTelInput({
            initialCountry: "auto",
            preferredCountries: ['be','de','en','es','fr','it','ch','us'],
            nationalMode: true,
            formatOnInit: true,
            geoIpLookup: function(callback) {
                var trans = {'en': 'gb'},
                    locale=Wlz.Settings.Header.locale
                    ;

                callback(trans[locale] ? trans[locale] : locale);
            },
            utilsScript: "/vendor-"+Wlz.Settings.version+"/intl-tel-input/build/js/utils.js" // just for formatting/placeholders etc
        });
        $phone.intlTelInput({
            initialCountry: "auto",
            preferredCountries: ['be','de','en','es','fr','it','ch','us'],
            nationalMode: true,
            formatOnInit: true,
            numberType: 'FIXED_LINE_OR_MOBILE',
            geoIpLookup: function(callback) {
                var trans = {'en': 'gb'},
                    locale=Wlz.Settings.Header.locale
                    ;

                callback(trans[locale] ? trans[locale] : locale);
            },
            utilsScript: "/vendor-"+Wlz.Settings.version+"/intl-tel-input/build/js/utils.js" // just for formatting/placeholders etc
        });

        $('#retreive-informations').submit(function(){
            $("#wlz_user_missing_information_retrieve_mobile").val($("#wlz_user_missing_information_retrieve_mobile").intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL));
            $("#wlz_user_missing_information_retrieve_phone1").val($("#wlz_user_missing_information_retrieve_phone1").intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL));
        });

        var $phones = $('#wlz_user_missing_information_retrieve_mobile, #wlz_user_missing_information_retrieve_phone1');
        $phones.on("keyup", function() {
            var $this = $(this);

            if(!$this.val().match($this.attr('pattern'))) {
                $this.parents('.form-group').addClass('has-error').find('.alert').removeClass('hidden');
            } else {
                $this.parents('.form-group').removeClass('has-error').find('.alert').addClass('hidden');
            }
        });

        $phones.keypress();
    }
})(jQuery);
